class DomFilter {
    constructor(itemContainer, filterContainer, itemSelector) {
        this.filterContainer = filterContainer
        this.itemContainer = itemContainer
        this.currentFilters = {}
        this.itemSelector = itemSelector

        this.registerEventHandling()
    }

    registerEventHandling() {
        this.filterContainer.querySelectorAll('select').forEach(select => {
            select.addEventListener('change', e => {
                const filterName = select.getAttribute('name')

                if (select.value) {
                    this.currentFilters[filterName] = select.value
                } else if (this.currentFilters[filterName]) {
                    delete this.currentFilters[filterName]
                }

                this.filterElements()
            })
        })
    }

    filterElements() {
        this.itemContainer.querySelectorAll(this.itemSelector).forEach(item => {
            let display = 'block'

            for (const [filterName, filterValue] of Object.entries(this.currentFilters)) {
                let itemValue = item.getAttribute('data-filter-' + filterName)

                if (itemValue !== filterValue) {
                    display = 'none'
                }
            }

            item.style.display = display
        })
    }
}

document.addEventListener("DOMContentLoaded", function(event) {
    let boatFilters = document.getElementById('boat-teaser-filters')
    let boatContainer = document.getElementById('boat-teaser-container')

    if (boatContainer != null && boatFilters != null) {
        const boatFilter = new DomFilter(boatContainer, boatFilters, '.boat-teaser')
    }
});
